module.exports = __webpack_public_path__ + "media/images/web/landings/students/s9-117eca9e2c4c377b5b27940961cb7326.jpg";